<template>
    <div>
        <ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery" :tabs="true"
            :table="false">
            <template slot="filters">
                <el-form-item label="发布人" prop="userId">
                    <el-input v-model="query.userId" placeholder="搜索用户手机号或ID" clearable
                        @keyup.enter.native="handleSearch" />
                </el-form-item>
                <el-form-item label="帖子标题" prop="title">
                    <el-input v-model="query.title" placeholder="搜索帖子标题或正文内容" clearable
                        @keyup.enter.native="handleSearch" />
                </el-form-item>
                <el-form-item label="发布时间" prop="date">
                    <el-date-picker v-model="query.date" value-format="yyyy-MM-dd" type="daterange" range-separator="~"
                        start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="机审结果" prop="status">
                    <el-select v-model="query.status" placeholder="请选择机审结果">
                        <el-option label="不通过" value="1"></el-option>
                        <el-option label="通过" value="2"></el-option>
                    </el-select>
                </el-form-item>
            </template>
            <template slot="tabs">
                <el-tabs v-model="query.auditStatus" @tab-click="search">
                    <el-tab-pane label="待审核" name="1"></el-tab-pane>
                    <el-tab-pane label="审核不通过记录" name="3"></el-tab-pane>
                </el-tabs>
            </template>
            <el-row v-if="tableData.length > 0" :gutter="20" class="pb-10">
                <el-col :span="8" v-for="item in tableData" :key="item.id" class="mb-5">
                    <el-card>
                        <div class="flex justify-between">
                            <div class="flex gap-x-3">
                                <img class="w-10 h-10 rounded-full" :src="item.avatar" alt="avatar" />
                                <div>
                                    <div class="font-bold">{{ item.userName }}</div>
                                    <div class="text-[#999] text-[12px]">{{ item.publishTime }}</div>
                                </div>
                            </div>
                            <div class="text-[#999] text-[12px]">ID: {{ item.userId }}</div>
                        </div>
                        <div class="font-bold">{{ item.title }}</div>
                        <div class="text-[#999]">{{ item.content }}</div> 
                        <div class="flex gap-x-3 gap-y-2 mt-3 flex-wrap">
                            <div v-for="(img, index) in item.imageUrls.split(',')" :key="index">
                                <img v-if="isImg(img)" class="h-20 rounded" :src="img" :alt="img.title" />
                                <video v-else class="h-20 rounded" style="width: 140px" :src="img" controls></video>
                            </div>
                        </div>
                        <div class="text-[14px] mt-3">{{ item.content }}</div>
                        <div v-if="query.auditStatus ==3" class="text-[#999] text-[14px] mt-3">不通过原因：{{ query.auditStatus == 1 ? item.autoReason :
                            item.reason }}
                        </div>
                        <div class="flex justify-between mt-3">
                            <div v-if="query.auditStatus == 1">
                                <el-button type="primary" size="mini" @click="handleAudit(2, item)">审核通过</el-button>
                                <el-button type="danger" size="mini" @click="handleAudit(3, item)">审核不通过</el-button>
                            </div>
                            <el-button v-else type="danger" size="mini" @click="handleDel(item)">删除</el-button>
                            <el-link v-if="item.autoAuditResult == 3" type="danger" :underline="false">机审不通过</el-link>
                            <el-link v-if="item.autoAuditResult == 2" type="success" :underline="false">机审通过</el-link>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
            <div v-else class="empty">暂无数据</div>
            <div class="fixed bottom-0 right-0 flex justify-between px-5 py-3 bg-white border-t"
                style="width: calc(100% - 200px)">
                <el-checkbox v-model="checked">本页全选</el-checkbox>
                <el-button type="primary" size="mini">批量{{ query.auditStatus == '1' ? '通过' : '删除' }}</el-button>
            </div>
        </ListPage>
        <el-dialog :visible.sync="visible" title="审核不通过" width="500px">
            <el-form :model="state">
                <el-form-item>
                    <el-select v-model="state.reason" placeholder="请选择不通过原因">
                        <el-option value="血腥暴力" label="血腥暴力"></el-option>
                        <el-option value="政治敏感" label="政治敏感"></el-option>
                        <el-option value="低俗色情" label="低俗色情"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="state.auditDesc" placeholder="请输入不通过说明" type="textarea"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="visible = false">取 消</el-button>
                <el-button type="primary" @click="handleConfirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { page, audit, del } from "@/api/community/post";
import listMixin from '@/mixins/list';
export default {
    data() {
        return {
            // 查询参数
            query: {
                auditStatus: "1",
                date: [],
                status: '',
                userId: '',
                title: ''
            },
            tableData: [],
            checked: false,
            state: {
                id: '',
                reason: '',
                auditDesc: ''
            },
            visible: false,
        };
    },
    mixins: [listMixin],
    methods: {
        search() {
            const num = /^[\d]*$/;
            if (!num.test(this.query.userId)) {
                this.$message.error('用户手机号或ID格式不正确')
                return;
            }
            this.loading = true;
            const params = {
                ...this.query,
                startTime: this.query.date[0] ? this.query.date[0] + ' 00:00:00' : '',
                endTime: this.query.date[1] ? this.query.date[1] + ' 23:59:59' : '',
            };
            delete params.date;
            page(params).then(({ code, result, message }) => {
                if (code == 200) {
                    this.tableData = result.records;
                    this.total = result.total;
                } else {
                    this.$message.error(message);
                }
                this.loading = false;
            });
        },
        isImg(img) {
            const ext = img.substring(img.lastIndexOf(".") + 1).toLowerCase();
            if (ext === 'jpg' || ext === 'jpeg' || ext === 'png' || ext === 'gif') {
                return true;
            }
            return false;
        },
        handleDetail(row) {
            this.$router.push({ path: "/community/post/detail", query: { id: row.id } });
        },
        handleDel(row) {
            this.$confirm('确定删除该帖子吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                del({ id: row.id }).then(({ code, message }) => {
                    if (code === 200) {
                        this.$message.success("删除成功");
                        this.search();
                    } else {
                        this.$message.error(message);
                    }
                })
            });
        },
        handleAudit(status, row) {
            if (status == 2) {
                this.$confirm('确定审核通过该帖子吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    audit({ id: row.id, auditResult: status }).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success("操作成功");
                            this.search();
                        } else {
                            this.$message.error(message);
                            this.loading = false;
                        }
                    });
                });
            } else {
                this.visible = true;
                this.state.id = row.id;
            }
        },
        handleConfirm() {
            audit({ id: this.state.id, auditResult: 3, ...this.state }).then(({ code, message }) => {
                if (code == 200) {
                    this.$message.success("操作成功");
                    this.visible = false;
                    this.search();
                } else {
                    this.$message.error(message);
                }
            });
        },
    },
};
</script>
<style lang="less" scoped>
.empty {
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #999;
}
</style>